import * as React from 'react'
// @mui
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
//
import App from './pdf_viewer/App'
import theme from './pdf_viewer/config/theme'
//

const PDFViewer = (props) => {
  // !!! Right click menu disabled !!!
  document.oncontextmenu = () => { return false }

  // main

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <App {...props} />
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default PDFViewer
